import React, { Component } from "react"
import { Link } from "react-router"
import { Button, Col, Row } from "elemental"
import { translate } from "translate"
import shop from "../../shop/shop"
import CartTotal from "../../components/Cart/CartTotal"
import ProductTable from "../../components/Product/ProductTable"
import "./CheckoutPage.scss"

export default class CheckoutPage extends Component {

  constructor() {
    super()
    this.state = {
      products: getProducts()
    }
  }

  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
  }

  handleChange = ( { product } ) => {
    shop.cart.add( product )
  }

  updateCart = () => {
    let products = getProducts()
    this.setState( { products } )
    this.forceUpdate()
  }

  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }

  render() {
    let { products } = this.state
    return (
      <div className="">
        <section>
          <Row className="top-bar tc">
            <Col sm="1/3"><Link to={"/checkout"}><strong>1. {translate( "cart.cart" )} </strong></Link></Col>
            <Col sm="1/3"><Link to={"/checkout/delivery"}>2. {translate( "cart.address" )}</Link></Col>
            <Col sm="1/3"><Link to={"/checkout/confirmation"}>3. {translate( "cart.check_and_submit" )}</Link></Col>
          </Row>
        </section>

        <section className="container">
          <h2>{translate( "cart.cart" )}</h2>
          <ProductTable cart={shop.cart} onChange={this.handleChange} products={products}/>
          <CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
        </section>

        <section className="pa2 mb4 bg-silver">
          <div className="container">
            <Row>
              <Col xs="1/2"
                   className="tl fl checkout-control">
                <Link to="/"> <Button type="link"> <i className="icon-angle-left"/> {translate( "shop.back" )} </Button></Link>
              </Col>

              <Col xs="1/2"
                   className="tr fr checkout-control">
                <Link to="/checkout/delivery"> <Button type="primary">{translate( "shop.continue" )}<i className="icon-angle-right"/>
                </Button></Link>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    )
  }

}

const getProducts = () => shop.cart.map( ( product ) => product )



// WEBPACK FOOTER //
// ./src/pages/checkout/CheckoutPage.js